import CustomLink from "@/components/Atoms/CustomLink";
import Image from "@/components/Atoms/Image";
import { List } from "@/components/Atoms/List";
import { SocialIcon } from "@/atoms/Vectors";

interface Props {
  data: any;
  color: any[any];
}

export function SocialLink({ data, color }: Props) {
  return (
    <List tag="ordered" style="">
      {data.map((entry: any, i: number) => {
        return entry.swapImage ? (
          <CustomLink target="_blank" key={i} href={`${entry.externalUrl}`}>
            <Image
              data={entry.image}
              className="max-w-[2rem]"
              ariaHidden={undefined}
              draggable={undefined}
              layout={undefined}
              lazyLoad={undefined}
            />
          </CustomLink>
        ) : (
          <CustomLink href={`${entry.externalUrl}`}>
            <SocialIcon color={color} type={entry.slug} />
          </CustomLink>
        );
      })}
    </List>
  );
}
